<template>
  <div class="detailContract" v-if="canAccessMx('CNPS_SCON_INFO_BY_ID')">
    <Header
      title="Chi tiết HĐĐT ngân lượng thanh toán"
      :backUrl="
        canAccessMx('CNPS_SCON_LIST_PAYMENT')
          ? '/contract-nganluong?groupService=PAYMENT'
          : '/contract-nganluong'
      "
    />
    <ContractAction :actions="defaultContractAction" :excepts="[actCode.EXPERTISE]" />
    <!-- End Breadcrumb Area -->
    <div class="row px-20 b-t-1-869fb229 pt-15">
      <div class="col-md-6 px-1">
        <McInfo
          :contract="dataContract"
          :item="customerInfo"
          :canEditMcc="canEditMcc"
          :dataConfigMcc="dataConfigMcc"
          :submitEditMcc="submitEditMcc"
        />
        <ContractInfo
          :contract="dataContract"
          :item="customerInfo"
          :hideReview="dataContract.isTransferNganluong"
        />
        <CusInfo :contract="dataContract" :item="customerInfo" />
        <BankInfo :comfirm="openUploadModalVertify" :contract="dataContract" :item="customerInfo" />
        <ReceiptInfo :contract="dataContract" :item="customerInfo" @fetch-data="fetchData" />
        <SupportContactInfos :item="customerInfo" :systemConfig="systemConfig" />
        <PaymentAcceptancePoint :contract="dataContract" :item="customerInfo" />
      </div>
      <div class="col-md-6 px-1">
        <div class="form-detail">
          <div>
            <UploadMultiple
              :lsData="dataPDFContract"
              keyUrl="dataURL"
              :canUpload="false"
              title="Upload file PDF"
              titleTag="h1"
              titleClass="form-inner-heading"
            >
              <div
                v-if="
                  ['SALE_ADMIN', 'SALE_DIRECTOR'].includes(dataUser.typeSale) &&
                  dataContract.state === 'SIGNED_WAITING_APPROVED'
                "
                @click="showAddImages('pdf')"
                class="add-img btn"
              >
                <span class="text-center bx bx-edit-alt"></span>
              </div>
            </UploadMultiple>
          </div>
          <div
            class="img-list-wrapper"
            v-if="
              dataContract.typeCustomer &&
              (dataContract.typeCustomer === 'HOUSEHOLD' ||
                dataContract.typeCustomer === 'COMPANY') &&
              customerInfo.businessScanUrl
            "
          >
            <h1 class="form-inner-heading">
              Ảnh giấy phép KD/Ảnh selfie/Ảnh sản phẩm/Ảnh cửa hàng...
            </h1>
            <div class="img-list">
              <ul v-viewer>
                <li v-for="(itemImg, index) in customerInfo.businessScanUrl" :key="index">
                  <a href="#popup-slider" data-toggle="modal">
                    <img :src="itemImg" alt="" />
                    <span
                      @click="removeImg(customerInfo.businessScanUrl, index, 'dkkd')"
                      v-if="
                        (dataUser.typeSale === 'SALE_ADMIN' ||
                          dataUser.typeSale === 'SALE_DIRECTOR') &&
                        dataContract.state === 'SIGNED_WAITING_APPROVED' &&
                        canAccessMx('CNPS_SCON_SAVE_IMAGES')
                      "
                      ><i class="bx bx-trash bx-sm"></i
                    ></span>
                  </a>
                </li>
                <li
                  v-if="customerInfo.businessScanUrl && customerInfo.businessScanUrl.length === 0"
                >
                  <div class="add-img">
                    <span class="font-size-12">Không có ảnh</span>
                  </div>
                </li>
                <li
                  v-if="
                    (dataUser.typeSale === 'SALE_ADMIN' || dataUser.typeSale === 'SALE_DIRECTOR') &&
                    dataContract.state === 'SIGNED_WAITING_APPROVED' &&
                    canAccessMx('CNPS_SCON_SAVE_IMAGES')
                  "
                >
                  <div class="ml-3 add-img">
                    <span class="text-center bx bx-plus"></span>
                    <input
                      @input="onSelectFile($event, 'dkkd', customerInfo.businessScanUrl)"
                      ref="fileInput"
                      type="file"
                    />
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div
            class="img-list-wrapper"
            v-if="
              dataContract.typeCustomer &&
              dataContract.typeCustomer === 'INDIVIDUAL' &&
              customerInfo.billScanUrl
            "
          >
            <h1 class="form-inner-heading">Ảnh hoá đơn/Ảnh selfie với cửa hàng/Ảnh sản phẩm...</h1>
            <div class="img-list">
              <ul v-viewer>
                <li v-for="(itemImg, index) in customerInfo.billScanUrl" :key="index">
                  <a href="#popup-slider" data-toggle="modal">
                    <img :src="itemImg" alt="" />
                    <span
                      v-if="
                        (dataUser.typeSale === 'SALE_ADMIN' ||
                          dataUser.typeSale === 'SALE_DIRECTOR') &&
                        dataContract.state === 'SIGNED_WAITING_APPROVED' &&
                        canAccessMx('CNPS_SCON_SAVE_IMAGES')
                      "
                      @click="removeImg(customerInfo.billScanUrl, index, 'bill')"
                      ><i class="bx bx-trash bx-sm"></i
                    ></span>
                  </a>
                </li>
                <li v-if="customerInfo.billScanUrl && customerInfo.billScanUrl.length === 0">
                  <div class="add-img">
                    <span class="font-size-12">Không có ảnh</span>
                  </div>
                </li>
                <li
                  v-if="
                    (dataUser.typeSale === 'SALE_ADMIN' || dataUser.typeSale === 'SALE_DIRECTOR') &&
                    dataContract.state === 'SIGNED_WAITING_APPROVED' &&
                    canAccessMx('CNPS_SCON_SAVE_IMAGES')
                  "
                >
                  <div class="add-img">
                    <span class="text-center bx bx-plus"></span>
                    <input
                      @input="onSelectFile($event, 'bill', customerInfo.billScanUrl)"
                      ref="fileInput"
                      type="file"
                    />
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div v-if="customerInfo.merchantBusinessAreas">
            <div
              class="img-list-wrapper"
              v-for="(item, index) in customerInfo.merchantBusinessAreas"
              :key="index"
            >
              <h1 class="form-inner-heading">
                Ảnh cửa hàng: {{ item.areaAddress }}
                <span v-show="item.areaDistrict"> - {{ item.areaDistrict }}</span>
                <span v-show="item.areaCity"> - {{ item.areaCity }}</span>
              </h1>
              <div class="img-list">
                <ul v-viewer>
                  <li v-for="(itemImg, indexx) in item.areaUrl" :key="indexx">
                    <a href="#popup-slider" data-toggle="modal">
                      <img :src="itemImg" alt="" />
                      <span
                        v-if="
                          (dataUser.typeSale === 'SALE_ADMIN' ||
                            dataUser.typeSale === 'SALE_DIRECTOR') &&
                          dataContract.state === 'SIGNED_WAITING_APPROVED' &&
                          canAccessMx('CNPS_SCON_SAVE_IMAGES')
                        "
                        @click="removeImg(item.areaUrl, indexx, 'merchant', item.id, item.areaName)"
                        ><i class="bx bx-trash bx-sm"></i
                      ></span>
                    </a>
                  </li>
                  <li v-if="(item.areaUrl && item.areaUrl.length === 0) || !item.areaUrl">
                    <div class="add-img">
                      <span class="font-size-12">Không có ảnh</span>
                    </div>
                  </li>
                  <li
                    v-if="
                      (dataUser.typeSale === 'SALE_ADMIN' ||
                        dataUser.typeSale === 'SALE_DIRECTOR') &&
                      dataContract.state === 'SIGNED_WAITING_APPROVED' &&
                      canAccessMx('CNPS_SCON_SAVE_IMAGES') &&
                      item.areaUrl &&
                      item.areaUrl.length < 1
                    "
                  >
                    <div class="add-img">
                      <span class="text-center bx bx-plus"></span>
                      <input
                        @input="onSelectFile($event, 'merchant', item.areaUrl, item.id)"
                        ref="fileInput"
                        type="file"
                      />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <UploadMultiple
            :lsData="customerInfo.passportScanUrl"
            :canUpload="false"
            title="Ảnh CMND/CCCD/Hộ chiếu"
            titleTag="h1"
            titleClass="form-inner-heading"
          />
          <UploadMultiple
            :lsData="dataContract.selfieOfMerchantByContract"
            :canUpload="false"
            title="Ảnh selfie với MC"
            titleTag="h1"
            titleClass="form-inner-heading"
          />
          <UploadMultiple
            v-if="dataContract.policyContractFiles"
            :lsData="dataContract.policyContractFiles"
            :canUpload="false"
            fileType="file"
            keyUrl="urlPDF"
            title="File PDF hợp dồng đề xuất chính sách"
            titleTag="h1"
            titleClass="form-inner-heading"
          />
          <UploadMultiple
            v-if="customerInfo.posBankUrls"
            :lsData="customerInfo.posBankUrls"
            :canUpload="false"
            title="Ảnh POS bank"
            titleTag="h1"
            titleClass="form-inner-heading"
          />
          <UploadMultiple
            v-if="customerInfo.finDocUrls"
            :lsData="customerInfo.finDocUrls"
            :canUpload="false"
            title="Ảnh chứng từ"
            titleTag="h1"
            titleClass="form-inner-heading"
          />
          <UploadMultiple
            v-if="customerInfo.businessAddressScanUrl"
            :lsData="customerInfo.businessAddressScanUrl"
            :canUpload="false"
            title="Địa điểm đăng ký kinh doanh"
            titleTag="h1"
            titleClass="form-inner-heading"
          />
        </div>
      </div>
      <div class="col-md-12 px-1">
        <AppendixFeeTrans
          :items="dataContract.lstAppendixTrans"
          :only="[
            'VIEW_APPENDIX',
            'APPROVE_REJECT',
            'OTP',
            'APPROVE_REJECT_FEE',
            'ADD_VIETQR_FEE_330',
            'REMOVE_VIETQR_FEE_330',
            'ADD_VIETQR_FEE_550',
            'REMOVE_VIETQR_FEE_550',
          ]"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixCredit
          :items="dataContract.lstAppendixCredits"
          :only="['VIEW_APPENDIX', 'APPROVE_REJECT', 'OTP', 'APPROVE_REJECT_FEE']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixRenewalSim
          @change="getDetailContract"
          v-if="dataContract.lstAppendixSimRenew"
          :items="dataContract.lstAppendixSimRenew"
        >
          <template #row-details="item">
            <AppendixRenewalSimDetail
              v-if="item?.appendixSimRenew.deviceInfos"
              :items="item?.appendixSimRenew.deviceInfos"
            />
          </template>
        </AppendixRenewalSim>
        <AppendixDevice
          :items="dataContract.lstAppendixDevices"
          :only="[
            'VIEW_APPENDIX',
            'RE_CREATE_RECEIPT',
            'APPROVE_REJECT',
            'OTP',
            'REQUEST_ADDITIONAL',
            'REMOVE_DEVICE',
            'HANOVER_APPROVE_REJECT_NEW',
            'CHANGE_FILE_APPENDIX_MPOS',
            'CPNS_SCON_GET_OTP',
            'CPNS_SCON_RESEMD_OTP',
          ]"
          :actions="defaultAppendixAction"
          :contract="dataContract"
          :cfgPolicyContract="this.cfgPolicyContract"
        />
        <AppendixMultiFunctional
          :items="dataContract.lstAppendixMultiFunctional"
          :only="[
            'VIEW_APPENDIX',
            'APPROVE_REJECT',
            'MULTI_FUNCTIONAL_APPROVE_REJECT',
            'CONFIRM_INFO_APPENDIX',
            'REQUEST_ADDITIONAL_OPTION',
            'REQUEST_ADDITIONAL_INFO',
          ]"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixCashback
          :items="dataContract.lstAppendixCashbacks"
          :only="[
            'VIEW_APPENDIX',
            'RE_CREATE_RECEIPT',
            'APPROVE_REJECT',
            'OTP',
            'REQUEST_ADDITIONAL',
            'REMOVE_DEVICE',
            'HANOVER_APPROVE_REJECT_NEW',
          ]"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixLend
          :items="dataContract.lstAppendixLends"
          :only="[
            'VIEW_APPENDIX',
            'APPROVE_REJECT',
            'REQUEST_ADDITIONAL',
            'RE_CREATE_RECEIPT',
            'REMOVE_DEVICE',
            'HANOVER_APPROVE_REJECT_NEW',
          ]"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixRent
          :items="dataContract.lstAppendixRents"
          :only="[
            'VIEW_APPENDIX',
            'APPROVE_REJECT',
            'REQUEST_ADDITIONAL',
            'RE_CREATE_RECEIPT',
            'REMOVE_DEVICE',
            'HANOVER_APPROVE_REJECT_NEW',
          ]"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixMoto
          :items="dataContract.lstAppendixMoto"
          :only="[
            'APPROVE_REJECT',
            'REQUEST_ADDITIONAL_OPTION',
            'RE_CREATE_RECEIPT',
            'CONFIRM_INFO_APPENDIX',
            'REQUEST_ADDITIONAL_INFO',
          ]"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixQR
          :items="dataContract.lstAppendixQr"
          :only="['VIEW_APPENDIX', 'APPROVE_REJECT', 'REQUEST_ADDITIONAL']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixUQNH
          :items="dataContract.lstAppendixAuthBanks"
          :only="['APPROVE_REJECT']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixVISA
          :items="dataContract.lstAppendixVisas"
          :only="['CREATE_APPENDIX_VISA', 'REJECT_VISA']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixUQKHD
          :items="dataContract.lstAppendixAuthContracts"
          :only="['APPROVE_REJECT']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixLiquid
          :items="dataContract.lstAppendixLiquidDates"
          :only="['VIEW_APPENDIX', 'APPROVE_REJECT_LIQUID', 'APPROVE_REJECT', 'OTP']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />

        <AppendixRecall
          :items="dataContract.lstAppendixRecalls"
          :only="[
            'VIEW_APPENDIX',
            'APPROVE_REJECT',
            'OTP',
            'REQUEST_ADDITIONAL',
            'CHANGE_FILE_APPENDIX_MPOS',
          ]"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />

        <AppendixHandover
          :items="dataContract.lstAppendixHandOvers"
          :only="[
            'VIEW_APPENDIX',
            'APPROVE_REJECT',
            'OTP',
            'REQUEST_ADDITIONAL',
            'CHANGE_FILE_APPENDIX_MPOS',
            'REMOVE_DEVICE',
          ]"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixTransfer
          :items="dataContract.lstAppendixTransfers"
          :only="[
            'VIEW_APPENDIX',
            'APPROVE_REJECT',
            'OTP',
            'REQUEST_ADDITIONAL',
            'CHANGE_FILE_APPENDIX_MPOS',
          ]"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixWarranties
          :items="dataContract.lstAppendixWarranties"
          :only="[
            'APPROVE_REJECT',
            'REQUEST_ADDITIONAL',
            'RE_CREATE_RECEIPT',
            'CHANGE_FILE_APPENDIX_MPOS',
          ]"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixOnUs
          :items="dataContract.lstAppendixOnUss"
          :only="['VIEW_APPENDIX', 'APPROVE_REJECT_FEE', 'APPROVE_REJECT']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixChange
          :items="dataContract.lstAppendixChange"
          :only="['']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixHomePayLater
          :items="dataContract.lstAppendixHPLs"
          :only="['VIEW_APPENDIX', 'APPROVE_REJECT_FEE', 'APPROVE_REJECT', 'REQUEST_ADDITIONAL']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixAppendixQrConnectors
          :items="dataContract.lstAppendixQrConnectors"
          :only="['VIEW_APPENDIX', 'APPROVE_REJECT_FEE', 'APPROVE_REJECT', 'REQUEST_ADDITIONAL']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixLinkCard
          :items="dataContract.lstAppendixLinkCards"
          :only="['VIEW_APPENDIX', 'APPROVE_REJECT_FEE', 'APPROVE_REJECT', 'REQUEST_ADDITIONAL']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <SignHistory :contractId="$route.params.id" />
        <div class="form-detail" v-if="historyUpdate.length > 0">
          <h1>Lịch sử chỉnh sửa thông tin hợp đồng</h1>
          <div class="table-responsive">
            <table class="table table-hover table-bordered">
              <thead class="thead-light">
                <tr>
                  <th scope="col" class="text-left">Thông tin chỉnh sửa</th>
                  <th scope="col" class="text-left">Thời gian</th>
                  <th scope="col" class="text-left">Sale</th>
                  <th scope="col" class="text-left">Người duyệt/ từ chối</th>
                  <th scope="col" class="text-left">Lý do từ chối</th>
                </tr>
              </thead>
              <tbody v-for="(item, index) in historyUpdate" :key="index">
                <tr class="table-row">
                  <td align="left">
                    <router-link :to="`/history-approve-update/${item.updateCusReqId}`"
                      >Xem chi tiết</router-link
                    >
                  </td>
                  <td align="left">
                    {{ item.createdDate | formatDate('HH:mm, DD/MM/YYYY') }} <br />
                  </td>
                  <td align="left">
                    {{ item.saleName }} <br />
                    <p class="text-primary">{{ item.saleEmail }}</p>
                  </td>
                  <td align="left">
                    <div v-if="item.rejectName">
                      {{ item.rejectName }} <br />
                      <p class="text-primary">{{ item.rejectEmail }}</p>
                    </div>
                    <div v-else>
                      {{ item.approverName }} <br />
                      <p class="text-primary">{{ item.approverEmail }}</p>
                    </div>
                  </td>
                  <td align="left">
                    {{ item.reason }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="form-detail" v-if="historyAssignSale.length > 0">
          <h1>Lịch sử gán hợp đồng</h1>
          <div class="table-responsive">
            <table class="table table-hover table-bordered">
              <thead class="thead-light">
                <tr>
                  <th scope="col" class="text-left">Thời gian</th>
                  <th scope="col" class="text-left">Sale cũ</th>
                  <th scope="col" class="text-left">Sale đang gán</th>
                  <th scope="col" class="text-left">Người gán</th>
                </tr>
              </thead>
              <tbody v-for="(item, index) in historyAssignSale" :key="index">
                <tr class="table-row">
                  <td align="left">
                    {{ item.createdDate | formatDate('HH:mm, DD/MM/YYYY') }} <br />
                  </td>
                  <td align="left">
                    {{ item.oldSaleName }} <br />
                    <p class="text-primary">{{ item.oldSaleEmail }}</p>
                  </td>
                  <td align="left">
                    {{ item.newSaleName }} <br />
                    <p class="text-primary">{{ item.newSaleEmail }}</p>
                  </td>
                  <td align="left">
                    {{ item.approverName }} <br />
                    <p class="text-primary">{{ item.approverEmail }}</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <HistoryInfo :dataContract="dataContract"></HistoryInfo>
      </div>
    </div>

    <b-modal id="modal-scoped" v-model="showmodalConfirmRemoveImage">
      <template #modal-header="{ close }">
        <h5>Xoá ảnh</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <h6>Bạn chắc chắn muốn xoá ảnh {{ typeImgAction }}</h6>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Bỏ qua </b-button>
        <b-button size="sm" variant="primary" @click="confirmRemove"> Đồng ý </b-button>
      </template>
    </b-modal>

    <approve-reject-component
      @reject="openReject"
      @approve="handleApproveHandover(dataContract.id)"
      :disable-upload="true"
      ref="modal-confirm"
      :selected-item="selectedItem"
    />

    <dkkd-modal ref="modal-dkkd" :contractId="dataContract.id" @approve="handleUpdateContract" />

    <tpv-modal ref="modal-tpv" :dataContract="dataContract" @approve="handleUpdateContract" />

    <b-modal id="modal-scoped" v-model="showModal" @hide="handleCloseReject">
      <template #modal-header="{ close }">
        <h5>Bạn chắc chắn muốn từ chối bàn giao thiết bị?</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="">
        <p class="f14 pb-2">Lý do từ chối yêu cầu</p>
        <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
          <form @submit.prevent="handleSubmit(handleReject)">
            <ValidationProvider rules="required|minMaxName_4" name="Lý do" v-slot="{ errors }">
              <b-form-group label="" label-for="floatingTextarea2">
                <b-form-textarea
                  id="floatingTextarea2"
                  v-model="reason"
                  placeholder="Lý do"
                  rows="3"
                  max-rows="6"
                  :state="errors.length > 0 ? false : null"
                >
                </b-form-textarea>
                <b-form-invalid-feedback id="input-live-feedback">{{
                  errors[0]
                }}</b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>
          </form>
        </ValidationObserver>
      </div>
      <template #modal-footer="{ close }">
        <b-button size="sm" variant="light" @click="close()"> Huỷ bỏ </b-button>
        <b-button size="sm" variant="primary" @click="handleReject"> Đồng ý </b-button>
      </template>
    </b-modal>
    <input
      ref="fileInput"
      type="file"
      accept="application/pdf"
      @change="handleFileChange"
      style="display: none"
    />
    <addPDF
      :showModalAddBillImages="showModalAddPDF"
      :dataImagesContract="dataPDFContract"
      :dataContract="dataContract"
      :generalImages="generalImages"
      @successImg="successUploadImg"
      @errorImg="showFailMx"
      @submitAddBillImages="addPDFImages"
      @close="closeAddImages('pdf')"
    >
    </addPDF>

    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
    <SelectEmployee @selectSale="assignNewSale" />
    <PopupApproveContract
      :customer-type="customerInfo?.customerType"
      :dataDetail="dataContract"
      ref="popupApproveContractRef"
      @approveContract="getDetailContract"
    />
    <UploadModalVertify
      ref="uploadModal"
      :visible="showUploadModal"
      :initialData="[]"
      @update:visible="showUploadModal = $event"
      @success="getDetailContract"
      :contractId="dataContract?.id"
      :customerId="dataContract?.customerId"
      :reqSellCode="dataContract?.reqSellCode"
    />
  </div>
</template>

<script>
  import { ContractService } from '@/services/contract.service'
  import Config from '../../thirdParty/config'
  import { CommonService } from '@/services/common.service'
  import 'vue-loading-overlay/dist/vue-loading.css'
  import mxActions from './mxActions'
  import mxAppendix from './mxAppendix'
  import HistoryInfo from './component/HistoryInfo.vue'
  import AddPDF from './modal-add-image/pdf-add-file.vue'
  import ApproveRejectComponent from '@/pages/device/equipmentHandover/components/ApproveRejectComponent.vue'
  import DkkdModal from '@/pages/contract/component/DkkdModal.vue'
  import TpvModal from '@/pages/contract/component/TpvModal.vue'
  import UploadModalVertify from './component/UploadModalVertify.vue'
  import AppendixRenewalSim from './component/appendix/AppendixRenewalSim.vue'
  import AppendixRenewalSimDetail from './component/appendix/AppendixRenewalSimDetail.vue'

  export default {
    data() {
      return {
        Config,
        limtImg: 0,
        dataContract: {},
        dataPDFContract: [],
        generalImages: [],
        showModalAddPDF: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataConfigMcc: [],
        ImageInsertSuccess: '',
        mcBusinessImagesArr: [],
        showmodalConfirmRemoveImage: false,
        confirmRemoveImage: false,
        typeImgAction: '',
        imageParams: {},
        showLoading: false,
        historyUpdate: [],
        historyAssignSale: [],
        selectedItem: {},
        showModal: false,
        reason: null,
        canEditMcc: false,
        dataChangeFileAppendixMpos: '',
        showUploadModal: false,
      }
    },

    components: {
      HistoryInfo,
      ApproveRejectComponent,
      DkkdModal,
      TpvModal,
      UploadModalVertify,
      AppendixRenewalSim,
      AppendixRenewalSimDetail,
      addPDF: AddPDF,
    },
    mixins: [mxActions, mxAppendix],
    async created() {
      this.fetchData()
      this.getConfigSystem()
    },
    methods: {
      successUploadImg(key) {
        this.showLoading = false
        if (key === 0) {
          this.showSuccessMx('Thêm phụ lục thành công')
        }
        if (key === 1) {
          this.showSuccessMx('Cập nhật ảnh thành công')
        }
        if (key === 2) {
          this.showSuccessMx('Cập nhật file PDF thành công')
        }
      },
      closeAddImages(key) {
        if (key === 'pdf') this.showModalAddPDF = false
        setTimeout(() => {
          this.getDetailContract()
        }, 200)
      },
      showAddImages(typeImage) {
        if (typeImage === 'pdf') this.showModalAddPDF = true
      },
      addPDFImages(data) {
        this.dataPDFContract = data.dataImages
        this.showModalAddPDF = false
      },
      openReject() {
        this.showModal = true
      },
      openUploadModalVertify() {
        this.showUploadModal = true
      },
      handleCloseReject() {
        this.reason = ''
      },
      async handleApproveHandover() {
        await this.confirmHandover('Duyệt xác nhận bàn giao', {
          action: 'SUCCESS',
          contractId: this.selectedItem.appendixId,
          contractType: 'APPENDIX',
        })
      },
      async handleReject() {
        const isValid = await this.$refs.observer.validate()
        if (!isValid) return
        this.showModal = false
        await this.confirmHandover('Từ chối bàn giao thiết bị', {
          action: 'REJECTED',
          contractId: this.selectedItem.appendixId,
          contractType: 'APPENDIX',
          reason: this.reason,
        })
      },

      async fetchData() {
        await this.getDetailContract()
        this.configSystem()
        await this.getHistoryUpdate()
        this.historySaleAssigned()
      },
      async getDetailContract() {
        try {
          this.showLoading = true
          const data = await ContractService.getDetailContractNganLuong({
            contractId: this.$route.params.id,
          })
          if (data.code === 1000 && data.data) {
            this.dataContract = data.data
            if (this.dataContract.generalImages) {
              this.dataPDFContract = this.dataContract.generalImages.filter(
                item => item.dataType === 'PDF'
              )
              this.generalImages = this.dataContract.generalImages
            }
            this.mcBusinessImagesArr = this.customerInfo.merchantBusinessAreas.map(item => {
              return {
                areaId: item.id,
                areaUrl: item.areaUrl,
              }
            })
          } else {
            this.showFailMx(data.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },

      async onSelectFile(event, key, imgData, itemIdCH) {
        const files = event.target.files

        const fomatUpload = ['image/jpeg', 'image/png']
        const checkFormat = fomatUpload.includes(files[0].type)
        if (!checkFormat) {
          alert('Định dạng ảnh không đúng')
          return
        }

        if (key === 'cmnd') this.limtImg = 2
        if (key === 'bill' || key === 'dkkd') this.limtImg = 99999
        if (key === 'merchant') this.limtImg = 1
        if (this.limtImg <= imgData.length) {
          this.showFailMx('Đã đạt ảnh tối đa , xóa ảnh cũ để thêm mới')
        }

        const FileSize = files[0].size / 1024 / 1024 // in MB

        if (FileSize > 5) {
          alert('File quá lớn. Vui lòng thử lại')
          return
        }

        this.formData2 = new FormData()
        this.formData2.append('files', files[0])
        this.formData2.append('folderName', 'nextpay_crm/images') // NextCrm
        console.log('files', this.formData2)
        if (files && files[0]) {
          const reader = new FileReader()
          reader.onload = e => {
            imgData.push(e.target.result)
          }
          reader.readAsDataURL(files[0])
        }

        if (key === 'merchant') this.uploadImage(key, itemIdCH)
        else this.uploadImage(key)
      },

      async uploadImage(typeImage, itemIdCH) {
        try {
          this.showLoading = true
          await CommonService.uploadImg(this.formData2).then(res => {
            if (res.code === 1000) {
              this.ImageInsertSuccess = res.data[0]
              if (typeImage === 'merchant') this.saveImage(typeImage, itemIdCH)
              else this.saveImage(typeImage)
            }
          })
        } catch (error) {
          console.log(error)
        }
      },

      async saveImage(typeImage, itemIdCH) {
        try {
          if (this.ImageInsertSuccess !== '') {
            if (typeImage === 'bill') {
              this.customerInfo.billScanUrl.splice(this.customerInfo.billScanUrl.length - 1, 1)
              this.customerInfo.billScanUrl.push(this.ImageInsertSuccess)
            }
            if (typeImage === 'dkkd') {
              this.customerInfo.businessScanUrl.splice(
                this.customerInfo.businessScanUrl.length - 1,
                1
              )
              this.customerInfo.businessScanUrl.push(this.ImageInsertSuccess)
            }
            if (typeImage === 'cmnd') {
              this.customerInfo.passportScanUrl.splice(
                this.customerInfo.passportScanUrl.length - 1,
                1
              )
              this.customerInfo.passportScanUrl.push(this.ImageInsertSuccess)
            }
            if (typeImage === 'merchant') {
              this.customerInfo.merchantBusinessAreas.map((item, index) => {
                if (item.id === itemIdCH) {
                  item.areaUrl.splice(item.areaUrl.length - 1, 1)
                  this.mcBusinessImagesArr[index] = {
                    areaId: item.id,
                    areaUrl: item.areaUrl.concat(this.ImageInsertSuccess),
                  }
                }
              })
            }

            const body = {
              billScanUrl: this.customerInfo.billScanUrl,
              businessScanUrl: this.customerInfo.businessScanUrl,
              customerId: this.customerInfo.customerId,
              merchantBusinessImagesList: this.mcBusinessImagesArr,
              passportScanUrl: this.customerInfo.passportScanUrl,
              productScanUrl: [],
              servicePackCode: this.dataContract.groupService,
              listServices: this.dataContract.serviceTypes,
            }
            const response = await ContractService.updateImg(body)
            if (response.code === 1000) {
              this.delayTime(700)
            } else {
              this.showFailMx(response.message)
              this.showLoading = false
            }
          }
        } catch (error) {
          console.log(error)
        }
      },

      delayTime(time) {
        setTimeout(() => {
          this.getDetailContract()
          this.showLoading = false
          this.showSuccessMx('Cập nhật thành công')
        }, time)
      },

      async confirmRemove() {
        this.confirmRemoveImage = true
        this.showLoading = true
        await this.removeImg(
          this.imageParams.imgData,
          this.imageParams.index,
          this.imageParams.key,
          this.imageParams.itemIdCH
        )
        this.showmodalConfirmRemoveImage = false
        this.confirmRemoveImage = false
      },

      async removeImg(imgData, index, key, itemIdCH, itemNameCH) {
        this.showmodalConfirmRemoveImage = true
        this.imageParams.imgData = imgData
        this.imageParams.index = index
        this.imageParams.key = key
        this.imageParams.itemIdCH = itemIdCH

        if (key === 'bill') this.typeImgAction = 'hoá đơn/ ảnh selfie'
        if (key === 'dkkd') this.typeImgAction = 'đăng ký kinh doanh'
        if (key === 'cmnd') this.typeImgAction = 'chứng minh nhân dân'
        if (key === 'merchant') this.typeImgAction = 'cửa hàng ' + itemNameCH

        if (this.confirmRemoveImage === false) {
          return
        }

        if (key === 'bill' || key === 'dkkd' || key === 'cmnd') {
          imgData.splice(index, 1)
        }
        if (key === 'merchant') {
          this.customerInfo.merchantBusinessAreas.map((e, i) => {
            if (e.id === itemIdCH) {
              imgData.splice(index, 1)
              const areaUrlArr = imgData
              this.mcBusinessImagesArr[i] = {
                areaId: e.id,
                areaUrl: areaUrlArr,
              }
            }
          })
        }
        await this.saveRemoveImage()
      },

      async saveRemoveImage() {
        try {
          const body = {
            billScanUrl: this.customerInfo.billScanUrl,
            businessScanUrl: this.customerInfo.businessScanUrl,
            customerId: this.customerInfo.customerId,
            merchantBusinessImagesList: this.mcBusinessImagesArr,
            passportScanUrl: this.customerInfo.passportScanUrl,
            productScanUrl: [],
            servicePackCode: this.dataContract.groupService,
            listServices: this.dataContract.serviceTypes,
          }
          const response = await ContractService.updateImg(body)
          if (response.code === 1000) {
            this.delayTime(700)
          } else {
            this.showFailMx(response.message)
            this.showLoading = false
          }
        } catch (error) {
          console.log(error)
        }
      },
      actionSelectFileAppendixMpos(appendixId) {
        this.$refs.fileInput.click()
        this.dataChangeFileAppendixMpos = appendixId
      },
      handleFileChange(event) {
        const file = event.target.files[0]
        if (file) {
          this.sendDocument(file)
        } else {
          console.log('Không có file nào được chọn.')
        }
      },
      async sendDocument(file) {
        try {
          if (file) {
            const formData = new FormData()
            formData.append('files', file)
            formData.append('folderName', 'NextCrm')
            const response = await CommonService.uploadFile(formData)
            if (response.code === 1000) {
              const urlFile = response.data
              this.changeFileAppendixMpos(urlFile)
              // return urlFile
            } else {
              this.showFailMx(response.message)
            }
          } else {
            return null
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async changeFileAppendixMpos(urlFile) {
        try {
          this.showLoading = true
          const body = {
            appendixId: this.dataChangeFileAppendixMpos,
            urlPdf: urlFile[0],
          }
          const response = await ContractService.changeFileAppendixMpos(body)
          if (response.code === 1000) {
            this.showSuccessMx('Thay đổi file thành công')
            this.getDetailContract()
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
          this.dataChangeFileAppendixMpos = ''
        }
      },
    },
  }
</script>

<style scoped>
  ::v-deep .dropdown.action-dropdown .dropdown-toggle::after {
    display: none !important;
  }

  ::v-deep .dropdown.action-dropdown > .btn,
  .dropdown .btn-sm {
    padding: 7px 15px !important;
  }

  ::v-deep .dropdown.action-dropdown .dropdown-menu {
    outline: none;
  }

  ::v-deep .dropdown.dropdown.action-dropdown .dropdown-item {
    width: 80%;
  }

  @media (max-width: 415px) {
    .btn-group {
      padding-bottom: 0;
    }
  }

  .breadcrumb-area {
    background: #f6e9c9 !important;
    margin-top: 0 !important;
    padding-top: 15px !important;
    padding-bottom: 5px !important;
  }
</style>
